import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { EventMobile } from '../../../libs/proto/mobile_pb';

@Injectable({
  providedIn: 'root'
})
export class EventConversionService {

  ToStorage(req: EventMobile) {
    const w = new BinaryWriter();
    EventMobile.serializeBinaryToWriter( req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (eventMobile: EventMobile, errorConvert: any) => void) {
    try {
      callback( EventMobile.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(eventMobile: EventMobile[]) {
    const rets = new Array<string>();

    eventMobile.forEach(element => {
      rets.push(
        btoa(String.fromCharCode.apply(null,this.ToStorage(element)))
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (EventMobile: EventMobile[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<EventMobile>();
    const empjs: {data: string[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = EventMobile.deserializeBinary( new Uint8Array([...atob(element)].map(char => char.charCodeAt(0)))  );
        emps.push ( emp );
      });
      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }
}

